export default __webpack_public_path__ + "static/media/youtubeIconCircle.2051bf96.svg";